import { render, staticRenderFns } from "./Inspiration.vue?vue&type=template&id=27f91d25"
import script from "./Inspiration.vue?vue&type=script&lang=js"
export * from "./Inspiration.vue?vue&type=script&lang=js"
import style0 from "./Inspiration.vue?vue&type=style&index=0&id=27f91d25&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports